<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span
            >{{ 'common.edit' | translate }} {{ type }} «{{ object?.Name }}» {{ 'edit-json.json' | translate }}</span
          >
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content full-height">
        <table class="ir-modal-table">
          <tr *ngIf="type">
            <td class="margin-big">
              <h2>
                <span>{{ 'edit-json.entity-type' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <span>{{ type }}</span>
              </div>
            </td>
          </tr>
          <tr *ngIf="object?.ETag">
            <td class="margin-big">
              <h2>
                <span>{{ 'edit-json.last-modification' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <span>{{ object?.ETag | date: 'dd/M/yy hh:mm:ss:a' }}</span>
              </div>
            </td>
          </tr>
        </table>

        <h2>
          <span>{{ 'edit-json.entity-data' | translate }}</span>
        </h2>
        <div class="ir-form-group" style="height: calc(100% - 120px)" #jsoneditor>
          <!-- <textarea class="ir-form-set" [(ngModel)]="json"></textarea> -->
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="update()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
